import React from 'react';
import './SurveyResponsesSurveyContactCard.css';
import logComponent from '../../common/logComponent';
import { format, parseISO } from 'date-fns';

export default function SurveyResponsesSurveyContactCard({ surveyContact, selected, onClick, fullWidth }) {

  if (logComponent('SurveyResponsesSurveyContactCard')) { console.debug('SurveyResponsesSurveyContactCard rendered'); }


  const handleClick = () => {
    if (logComponent('SurveyResponsesSurveyContactCard')) { console.debug('SurveyResponsesSurveyContactCard handleClick'); }
    onClick(surveyContact);
  }

  return (
    <li className={'Survey-Responses-Survey-Contact-Card' + (selected ? ' Survey-Responses-Survey-Contact-Card--selected' : '')}>
      <React.Fragment>
        {fullWidth &&
          <button onClick={handleClick}>


            <div>
              <p className="Survey-Responses-Survey-Contact-Card__name">{`Contact: ${surveyContact.name}`}</p>
              {
                surveyContact.monitoredIndividuals && surveyContact.monitoredIndividuals.length == 1 &&
                <p className="Survey-Responses-Survey-Contact-Card__name">{`Individual: ${surveyContact.monitoredIndividuals[0].legalFirstName} ${surveyContact.monitoredIndividuals[0].lastName}`}</p>
              }
              {
                surveyContact.monitoredIndividuals && surveyContact.monitoredIndividuals.length > 1 &&
                <p className="Survey-Responses-Survey-Contact-Card__name">Multiple Recipients</p>
              }
              {
                surveyContact.monitoredIndividuals && surveyContact.monitoredIndividuals.length > 0 && surveyContact.monitoredIndividuals && surveyContact.monitoredIndividuals[0].surveyResponses.length > 0 &&
                <p className="Survey-Responses-Survey-Contact-Card__date">{`Response on: ${format(parseISO(surveyContact.monitoredIndividuals[0].surveyResponses[0].localStartOn), 'MM/dd/yyyy')}`}</p>

              }
            </div>
          </button>
        }
        {!fullWidth &&
          <React.Fragment>
            <div className="Survey-Responses-Survey-Contact-Card__contact">
              <p className="Survey-Responses-Survey-Contact-Card__name">{`Contact: ${surveyContact.name}`}</p>
              {
                surveyContact.monitoredIndividuals && surveyContact.monitoredIndividuals.length == 1 &&
                <p className="Survey-Responses-Survey-Contact-Card__name">{`Individual: ${surveyContact.monitoredIndividuals[0].legalFirstName} ${surveyContact.monitoredIndividuals[0].lastName}`}</p>
              }
              {
                surveyContact.monitoredIndividuals && surveyContact.monitoredIndividuals.length > 1 &&
                <p className="Survey-Responses-Survey-Contact-Card__name">Multiple Recipients</p>
              }
              {
                surveyContact.monitoredIndividuals && surveyContact.monitoredIndividuals.length > 0 && surveyContact.monitoredIndividuals && surveyContact.monitoredIndividuals[0].surveyResponses.length > 0 &&
                <p className="Survey-Responses-Survey-Contact-Card__date">{`Response on: ${format(parseISO(surveyContact.monitoredIndividuals[0].surveyResponses[0].localStartOn), 'MM/dd/yyyy')}`}</p>

              }
            </div>
            <button className="Survey-Responses-Survey-Contact-Card__view-responses" onClick={handleClick}>View Responses</button>
          </React.Fragment>
        }
      </React.Fragment>
    </li>
  );
}


